// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import TdsHeroImg from "../../asset/Accounting.png";   // Hero background image (replace if needed)
// import TdsCenterImg from "../../asset/image1.png";     // Center image in TDS section
// import TdsRightImg from "../../asset/image4.png";      // Right-side image for TDS points section
// import LineImg from "../../asset/line1.png";           // Line image
// import pointImg from "../../asset/point.png";          // Icon for points
// import "./ServiceBusiness.css";                        // Create this CSS or reuse the same as others

// const ServiceTds = () => {
//   return (
//     <div>
//       {/* Hero Section */}
//       <div
//         className="services-hero"
//         style={{
//           backgroundImage: `url(${TdsHeroImg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "88vh",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//         }}
//       >
//         {/* Dark Overlay */}
//         <div className="services-overlay"></div>
      
//         {/* Hero Content */}
//         <div className="services-content">
//           <h1 className="services-heading">Building Trust Through Transparency</h1>
//           <p className="services-paragraph">
//             We deliver through audits and assurance services that enhance credibility,
//             accuracy and confidence for your stakeholders.
//           </p>
//         </div>
//       </div>

//       {/* TDS Image Section */}
//       <div className="detail-section">
//         <Container className="text-center">
//           <div className="d-flex align-items-center justify-content-center flex-wrap">
//             <img src={LineImg} alt="line-left" className="side-line" />

//             <div className="center-image-wrapper">
//               {/* <img src={TdsCenterImg} alt="TDS Services" className="side-image" /> */}
//               <div className="image-text">Tax Deducted at Services</div>
//             </div>

//             <img src={LineImg} alt="line-right" className="side-line mirrored" />
//           </div>
//         </Container>
//       </div>

//       {/* Service Points Section */}
//       <div className="service-image-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Column with Points */}
//             <Col md={6}>
//               <ul className="service-points">
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Advisory on TDS/TCS compliance
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Advisory on TDS/TCS compliance
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   TAN Registration
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Monthly TDS Computation & Reconciliation
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Timely Depostis of TDS
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Issuance of Certificates(Form 16/16A)
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Filing of Quarterly Return & Corrections
//                 </li>
//                  <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Representation in TDS Assessments
//                 </li>
//               </ul>
//             </Col>

//             {/* Right Column with Image */}
//             <Col md={6} className="text-center text-md-end">
//               <img src={TdsRightImg} alt="TDS Service Detail" className="service-right-image" />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default ServiceTds;


import React, { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import TdsRightImg from "../../asset/tdsService.webp";   // Right-side image
import LineImg from "../../asset/line1.png";        // Decorative line
import tdsImg  from "../../asset/Accounting.webp";
import pointImg from "../../asset/point.png";       // Icon for points
import "./ServiceBusiness.css";

// ✅ Memoized service point component
const ServicePoint = memo(({ text }) => (
  <li>
    <img src={pointImg} alt="icon" className="point-icon" loading="lazy" />
    {text}
  </li>
));

const ServiceTds = () => {
  const servicePoints = [
    "Advisory on TDS/TCS compliance",
    "TAN Registration",
    "Monthly TDS Computation & Reconciliation",
    "Timely Deposits of TDS",
    "Issuance of Certificates (Form 16/16A)",
    "Filing of Quarterly Return & Corrections",
    "Representation in TDS Assessments",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="services-hero tds-hero"
       style={{
    backgroundImage: `url(${ tdsImg })`, // ✅ Use template literal with imported image
  }}
      >
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1 className="services-heading">Building Trust Through Transparency</h1>
          <p className="services-paragraph">
            We deliver through TDS services that enhance credibility, accuracy and confidence for your stakeholders.
          </p>
        </div>
      </div>

      {/* Center Section */}
      <div className="detail-section">
        <Container className="text-center">
          <div className="d-flex align-items-center justify-content-center flex-wrap">
            <img src={LineImg} alt="line-left" className="side-line" loading="lazy" />
            <div className="center-image-wrapper">
              <div className="image-text">Tax Deducted at Source (TDS)</div>
            </div>
            <img src={LineImg} alt="line-right" className="side-line mirrored" loading="lazy" />
          </div>
        </Container>
      </div>

      {/* Service Points Section */}
      <div className="service-image-section">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <ul className="service-points">
                {servicePoints.map((point, index) => (
                  <ServicePoint key={index} text={point} />
                ))}
              </ul>
            </Col>
            <Col md={6} className="text-center text-md-end">
              <img
                src={TdsRightImg}
                alt="TDS Service Detail"
                className="service-right-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default memo(ServiceTds);
